import FooterCheckoutView from './footer-checkout-view'

export default FooterCheckoutView
